import CustomCardHeader from "../../components/card/CustomCardHeader";
import {SemiTransparentButton} from "../../components/CustomButton";
import CardBody from "../../components/card/CardBody";
import CustomTable from "../../components/table/CustomTable";
import CustomCard from "../../components/card/CustomCard";
import {useDispatch, useSelector} from "react-redux";
import AddFeatureTableHeader from "./components/AddFeatureTableHeader";
import AddFeatureTable from "./components/AddFeatureTable";
import {resetFeatures, setManageFeatureModals} from "../../redux/slices/permissionSlice";
import {useEffect} from "react";
import CreateFeatureFormModal from "./components/CreateFeatureFormModal";
import {NORMAL_USERS} from "../user/constants";
import {setManageUserModals} from "../../redux/slices/manageUserSlice";
import FeatureConfirmModal from "./components/FeatureConfirmModal";
import AddPermissionsModal from "./components/AddPermissionsModal";

export default function AssignPermission() {

  const dispatch = useDispatch();


  useEffect(() => {

    return () => {
      dispatch(resetFeatures());
    };
  }, []);

  return (
    <>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <CustomCard>
              <CustomCardHeader color="blue" contentPosition="none">
                <div className="flex items-center justify-between w-full">
                  <h2 className="text-2xl text-white">Assign Permissions</h2>
                  <div className="flex space-x-2">
                    <CreateFeatureButton/>
                  </div>

                </div>
              </CustomCardHeader>
              <CardBody>
                <div className="overflow-x-auto">
                  <CustomTable className="table-fixed">
                    <AddFeatureTableHeader/>
                    <AddFeatureTable/>
                  </CustomTable>
                </div>
              </CardBody>
            </CustomCard>
            <CreateFeatureFormModal/>
            <FeatureConfirmModal/>
            <AddPermissionsModal/>
          </div>
        </div>
      </div>
    </>
  );
}

const CreateFeatureButton = () => {
  const dispatch = useDispatch();

  return (
        <SemiTransparentButton onClick={() => dispatch(setManageFeatureModals({modal: true}))}>
          Create Feature
        </SemiTransparentButton>
  );
};
